import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent } from '@sb/library/base';
import { WebsiteBlockTextAndMediaDisplayItem } from '@sb/library/data-models';

@Component({
    selector: 'lib-html-design-block',
    templateUrl: './html-design-block.component.html',
    styleUrls: ['./html-design-block.component.scss']
})
export class HtmlDesignBlockComponent extends DesignBlockBaseViewComponent {
    @Input() websiteBlockData!: WebsiteBlockTextAndMediaDisplayItem;
}
